/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import FnfARModalController from '../../Modals/ActionRequiredModals/FnfARModal/FnfARModalController';
import { useAppSelector } from '../../../infra/hooks';
import _ from 'lodash';
import { getAmount } from '../../configs/utils';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}

const FnF = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState<any>({});

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const handleTransferView = (complaint: any) => {
    setFullData(complaint);
  };
  const getStatus = ['Pending', 'Approved', 'Rejected'];

  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params?.row?.empName}
            picture={params?.row?.empPic}
          />
        );
      },
    },
    {
      field: 'department',
      headerName: trans('Department'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'hireDate',
      headerName: trans('Hire Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.hireDate}
          format={baseDateFormatting}
        />
      ),
    },
    {
      field: 'startDate',
      headerName: trans('Start Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.startDate}
          format={baseDateFormatting}
        />
      ),
    },
    {
      field: 'exitDate',
      headerName: trans('Exit Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.exitDate}
          format={baseDateFormatting}
        />
      ),
    },
    {
      field: 'exitType',
      headerName: trans('Exit Type'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'typeOfContract',
      headerName: trans('Type of Contract'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'payrollSalary',
      headerName: trans('Payroll Salary'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'status',
      headerName: trans('Status'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleTransferView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      empId: `#${data?.fnf_settlement?.employee?.staff_id}`,
      empName: `${data?.fnf_settlement?.employee?.first_name} ${data?.fnf_settlement?.employee?.last_name}`,
      department:
        data?.fnf_settlement?.employee?.emp_job_detail?.department?.name,
      hireDate: data?.fnf_settlement?.employee?.emp_job_detail?.hire_date,
      startDate: data?.termination_notice_date ?? '--',
      exitDate: data?.fnf_settlement?.emp_offboarding?.date ?? '--',
      exitType: data?.fnf_settlement?.emp_offboarding?.type,
      typeOfContract:
        data?.fnf_settlement?.employee?.emp_job_detail?.contract_type?.name,
      payrollSalary: getAmount(data?.fnf_settlement?.payroll_salary),
      status: getStatus[data?.status],
      fullData: data,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          disableColumnMenu
          localeText={isRTL ? arabicDataGrid : undefined}
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <FnfARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          fullData={fullData}
        />
      )}
    </>
  );
};

export default FnF;
